import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import qs from 'query-string';

export class PublicRoute extends Component {
  render() {
    if (this.props.loggedIn) {
      const parsed = qs.parse(this.props.location.search);
      return <Redirect to={parsed.redirectTo ? parsed.redirectTo : '/'} />;
    }

    const rest = {
      ...this.props
    };
    delete rest.component;

    const Cmp = this.props.component;

    return <Cmp {...rest} />;
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.auth.loggedIn
  };
}

export default connect(mapStateToProps)(withRouter(PublicRoute));



// WEBPACK FOOTER //
// ./src/components/publicRoute/publicRoute.jsx